import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateCompanyEntity } from '../../domain/entities/CreateUpdateCompanyEntity'
import { CompanyOrderPeriodModel } from './CompanyOrderPeriodModel'

export class CreateUpdateCompanyModel extends CreateUpdateCompanyEntity {
 serviceId!: number
 mealTierId!: number
 branchIds?: Array<number> | null

  constructor(dataDto: CreateUpdateCompanyEntity) {
    super()
    mapEntityProperties<CreateUpdateCompanyModel>(this, dataDto,{
      exclude: ['service', 'mealTier' , 'branchs'],
      map: {
        serviceId: dataDto.service?.id,
        mealTierId: dataDto.mealTier?.id,
        branchIds: dataDto.branchs?.map((branch) => branch.id),
        periods: dataDto.periods?.map((period) => new CompanyOrderPeriodModel(period)),
        subscription: dataDto.subscription
          ? {
              startDate: dataDto.subscription.startDate,
              endDate: dataDto.subscription.endDate
            }
          : undefined
      }
    })
  }
}
